import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace NotificationsFields {
  export enum NewStartUpDocumentField {
    EnableMini = 'NewSsuDocument.EnableMini',
    EnableMiniDefault = 'NewSsuDocument.EnableMiniDefault',
    EnableMiniMandatory = 'NewSsuDocument.EnableMiniMandatory',
    EnableDelayed = 'NewSsuDocument.EnableDelayed',
    EnableDelayedDefault = 'NewSsuDocument.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewSsuDocument.EnableDelayedMandatory',
  }

  export enum UpdateStartUpDocumentField {
    EnableMini = 'UpdateSsuDocument.EnableMini',
    EnableMiniDefault = 'UpdateSsuDocument.EnableMiniDefault',
    EnableMiniMandatory = 'UpdateSsuDocument.EnableMiniMandatory',
    EnableDelayed = 'UpdateSsuDocument.EnableDelayed',
    EnableDelayedDefault = 'UpdateSsuDocument.EnableDelayedDefault',
    EnableDelayedMandatory = 'UpdateSsuDocument.EnableDelayedMandatory',
  }

  export enum NewDocumentField {
    EnableMini = 'NewDocument.EnableMini',
    EnableMiniDefault = 'NewDocument.EnableMiniDefault',
    EnableMiniMandatory = 'NewDocument.EnableMiniMandatory',
    EnableDelayed = 'NewDocument.EnableDelayed',
    EnableDelayedDefault = 'NewDocument.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewDocument.EnableDelayedMandatory',
  }

  export enum UpdateDocumentField {
    EnableMini = 'UpdateDocument.EnableMini',
    EnableMiniDefault = 'UpdateDocument.EnableMiniDefault',
    EnableMiniMandatory = 'UpdateDocument.EnableMiniMandatory',
    EnableDelayed = 'UpdateDocument.EnableDelayed',
    EnableDelayedDefault = 'UpdateDocument.EnableDelayedDefault',
    EnableDelayedMandatory = 'UpdateDocument.EnableDelayedMandatory',
  }

  export enum RejectDocumentField {
    EnableMini = 'RejectDocument.EnableMini',
    EnableMiniDefault = 'RejectDocument.EnableMiniDefault',
    EnableMiniMandatory = 'RejectDocument.EnableMiniMandatory',
    EnableDelayed = 'RejectDocument.EnableDelayed',
    EnableDelayedDefault = 'RejectDocument.EnableDelayedDefault',
    EnableDelayedMandatory = 'RejectDocument.EnableDelayedMandatory',
  }

  export enum RegulatoryPendingField {
    EnableMini = 'RegulatoryPending.EnableMini',
    EnableMiniDefault = 'RegulatoryPending.EnableMiniDefault',
    EnableMiniMandatory = 'RegulatoryPending.EnableMiniMandatory',
    EnableDelayed = 'RegulatoryPending.EnableDelayed',
    EnableDelayedDefault = 'RegulatoryPending.EnableDelayedDefault',
    EnableDelayedMandatory = 'RegulatoryPending.EnableDelayedMandatory',
  }

  export enum RegulatoryApprovedField {
    EnableMini = 'RegulatoryApproved.EnableMini',
    EnableMiniDefault = 'RegulatoryApproved.EnableMiniDefault',
    EnableMiniMandatory = 'RegulatoryApproved.EnableMiniMandatory',
    EnableDelayed = 'RegulatoryApproved.EnableDelayed',
    EnableDelayedDefault = 'RegulatoryApproved.EnableDelayedDefault',
    EnableDelayedMandatory = 'RegulatoryApproved.EnableDelayedMandatory',
  }

  export enum RegulatoryRejectedField {
    EnableMini = 'RegulatoryRejected.EnableMini',
    EnableMiniDefault = 'RegulatoryRejected.EnableMiniDefault',
    EnableMiniMandatory = 'RegulatoryRejected.EnableMiniMandatory',
    EnableDelayed = 'RegulatoryRejected.EnableDelayed',
    EnableDelayedDefault = 'RegulatoryRejected.EnableDelayedDefault',
    EnableDelayedMandatory = 'RegulatoryRejected.EnableDelayedMandatory',
  }

  export enum SponsorPendingField {
    EnableMini = 'SponsorPending.EnableMini',
    EnableMiniDefault = 'SponsorPending.EnableMiniDefault',
    EnableMiniMandatory = 'SponsorPending.EnableMiniMandatory',
    EnableDelayed = 'SponsorPending.EnableDelayed',
    EnableDelayedDefault = 'SponsorPending.EnableDelayedDefault',
    EnableDelayedMandatory = 'SponsorPending.EnableDelayedMandatory',
  }

  export enum SponsorApprovedField {
    EnableMini = 'SponsorApproved.EnableMini',
    EnableMiniDefault = 'SponsorApproved.EnableMiniDefault',
    EnableMiniMandatory = 'SponsorApproved.EnableMiniMandatory',
    EnableDelayed = 'SponsorApproved.EnableDelayed',
    EnableDelayedDefault = 'SponsorApproved.EnableDelayedDefault',
    EnableDelayedMandatory = 'SponsorApproved.EnableDelayedMandatory',
  }

  export enum SponsorRejectedField {
    EnableMini = 'SponsorRejected.EnableMini',
    EnableMiniDefault = 'SponsorRejected.EnableMiniDefault',
    EnableMiniMandatory = 'SponsorRejected.EnableMiniMandatory',
    EnableDelayed = 'SponsorRejected.EnableDelayed',
    EnableDelayedDefault = 'SponsorRejected.EnableDelayedDefault',
    EnableDelayedMandatory = 'SponsorRejected.EnableDelayedMandatory',
  }

  export enum WorkflowQueryResolutionSentField {
    EnableMini = 'NewQueryResponse.EnableMini',
    EnableMiniDefault = 'NewQueryResponse.EnableMiniDefault',
    EnableMiniMandatory = 'NewQueryResponse.EnableMiniMandatory',
    EnableDelayed = 'NewQueryResponse.EnableDelayed',
    EnableDelayedDefault = 'NewQueryResponse.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewQueryResponse.EnableDelayedMandatory',
  }

  export enum AuditQueryResolutionSentField {
    EnableMini = 'NewAuditQueryResponse.EnableMini',
    EnableMiniDefault = 'NewAuditQueryResponse.EnableMiniDefault',
    EnableMiniMandatory = 'NewAuditQueryResponse.EnableMiniMandatory',
    EnableDelayed = 'NewAuditQueryResponse.EnableDelayed',
    EnableDelayedDefault = 'NewAuditQueryResponse.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewAuditQueryResponse.EnableDelayedMandatory',
  }

  export enum NewQuestionField {
    EnableMini = 'NewQuestion.EnableMini',
    EnableMiniDefault = 'NewQuestion.EnableMiniDefault',
    EnableMiniMandatory = 'NewQuestion.EnableMiniMandatory',
    EnableDelayed = 'NewQuestion.EnableDelayed',
    EnableDelayedDefault = 'NewQuestion.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewQuestion.EnableDelayedMandatory',
  }

  export enum NewAnswerField {
    EnableMini = 'NewAnswer.EnableMini',
    EnableMiniDefault = 'NewAnswer.EnableMiniDefault',
    EnableMiniMandatory = 'NewAnswer.EnableMiniMandatory',
    EnableDelayed = 'NewAnswer.EnableDelayed',
    EnableDelayedDefault = 'NewAnswer.EnableDelayedDefault',
    EnableDelayedMandatory = 'NewAnswer.EnableDelayedMandatory',
  }

  export enum FirstVisitField {
    EnableMini = 'FirstTimeVisit.EnableMini',
    EnableMiniDefault = 'FirstTimeVisit.EnableMiniDefault',
    EnableMiniMandatory = 'FirstTimeVisit.EnableMiniMandatory',
    EnableDelayed = 'FirstTimeVisit.EnableDelayed',
    EnableDelayedDefault = 'FirstTimeVisit.EnableDelayedDefault',
    EnableDelayedMandatory = 'FirstTimeVisit.EnableDelayedMandatory',
  }

  export enum RegistrationField {
    EnableMini = 'UserInvitation.EnableMini',
    EnableMiniDefault = 'UserInvitation.EnableMiniDefault',
    EnableMiniMandatory = 'UserInvitation.EnableMiniMandatory',
    EnableDelayed = 'UserInvitation.EnableDelayed',
    EnableDelayedDefault = 'UserInvitation.EnableDelayedDefault',
    EnableDelayedMandatory = 'UserInvitation.EnableDelayedMandatory',
  }

  export enum SwimLaneField {
    EnableMini = 'SwimLane.EnableMini',
    EnableMiniDefault = 'SwimLane.EnableMiniDefault',
    EnableMiniMandatory = 'SwimLane.EnableMiniMandatory',
    EnableDelayed = 'SwimLane.EnableDelayed',
    EnableDelayedDefault = 'SwimLane.EnableDelayedDefault',
    EnableDelayedMandatory = 'SwimLane.EnableDelayedMandatory',
  }

  export enum ClaimField {
    EnableMini = 'Claim.EnableMini',
    EnableMiniDefault = 'Claim.EnableMiniDefault',
    EnableMiniMandatory = 'Claim.EnableMiniMandatory',
    EnableDelayed = 'Claim.EnableDelayed',
    EnableDelayedDefault = 'Claim.EnableDelayedDefault',
    EnableDelayedMandatory = 'Claim.EnableDelayedMandatory',
  }

  export enum ReminderField {
    EnableMini = 'Reminder.EnableMini',
    EnableMiniDefault = 'Reminder.EnableMiniDefault',
    EnableMiniMandatory = 'Reminder.EnableMiniMandatory',
    EnableDelayed = 'Reminder.EnableDelayed',
    EnableDelayedDefault = 'Reminder.EnableDelayedDefault',
    EnableDelayedMandatory = 'Reminder.EnableDelayedMandatory',
  }

  export enum EscalationField {
    EnableMini = 'Escalation.EnableMini',
    EnableMiniDefault = 'Escalation.EnableMiniDefault',
    EnableMiniMandatory = 'Escalation.EnableMiniMandatory',
    EnableDelayed = 'Escalation.EnableDelayed',
    EnableDelayedDefault = 'Escalation.EnableDelayedDefault',
    EnableDelayedMandatory = 'Escalation.EnableDelayedMandatory',
  }

  export enum ReleaseField {
    EnableMini = 'Release.EnableMini',
    EnableMiniDefault = 'Release.EnableMiniDefault',
    EnableMiniMandatory = 'Release.EnableMiniMandatory',
    EnableDelayed = 'Release.EnableDelayed',
    EnableDelayedDefault = 'Release.EnableDelayedDefault',
    EnableDelayedMandatory = 'Release.EnableDelayedMandatory',
  }

  export enum TestModeField {
    Enabled = 'TestMode.Enabled',
    Recipients = 'TestMode.Recipients',
  }

  export enum GeneralField {
    EmptyNightlyEnabled = 'EmptyNightlyNotification.Enabled',
  }

  export enum MiniNewsLetterField {
    SendPeriod = 'MiniNewsletter.SendPeriod',
  }
}

class NewStartUpDocument extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewStartUpDocumentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class UpdateStartUpDocument extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateStartUpDocumentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class NewDocument extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewDocumentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class UpdateDocument extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.UpdateDocumentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class RejectDocument extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RejectDocumentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class RegulatoryPending extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryPendingField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class RegulatoryApproved extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryApprovedField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class RegulatoryRejected extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegulatoryRejectedField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class SponsorPending extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorPendingField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class SponsorApproved extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorApprovedField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class SponsorRejected extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SponsorRejectedField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class WorkflowQueryResolutionSent extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.WorkflowQueryResolutionSentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class AuditQueryResolutionSent extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableMini, false)
  enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.AuditQueryResolutionSentField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class NewQuestion extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewQuestionField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class NewAnswer extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.NewAnswerField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class FirstVisit extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.FirstVisitField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class Registration extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.RegistrationField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class SwimLane extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableDelayed, false) enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.SwimLaneField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class Claim extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableDelayed, false) enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ClaimField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class Reminder extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableDelayed, false) enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReminderField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class Escalation extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableDelayed, false)
  enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.EscalationField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class Release extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableMini, false) enableMini: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableMiniDefault, false)
  enableMiniDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableMiniMandatory, false)
  enableMiniMandatory: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableDelayed, false) enableDelayed: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableDelayedDefault, false)
  enableDelayedDefault: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.ReleaseField.EnableDelayedMandatory, false)
  enableDelayedMandatory: SettingValue<boolean>;
}

class TestMode extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.TestModeField.Enabled, false) enabled: SettingValue<boolean>;
  @SettingsSubModule.value(NotificationsFields.TestModeField.Recipients, '') recipients: SettingValue<string>;
}

class General extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.GeneralField.EmptyNightlyEnabled, false)
  emptyNightlyEnabled: SettingValue<boolean>;
}

class MiniNewsLetter extends SettingsSubModule {
  @SettingsSubModule.value(NotificationsFields.MiniNewsLetterField.SendPeriod, 0) sendPeriod: SettingValue<number>;
}

export class NotificationsModule extends SettingsModule {
  @SettingsModule.value(NewStartUpDocument) newStartUpDocument: NewStartUpDocument;
  @SettingsModule.value(UpdateStartUpDocument) updateStartUpDocument: UpdateStartUpDocument;
  @SettingsModule.value(NewDocument) newDocument: NewDocument;
  @SettingsModule.value(UpdateDocument) updateDocument: UpdateDocument;
  @SettingsModule.value(RejectDocument) rejectDocument: RejectDocument;
  @SettingsModule.value(RegulatoryPending) regulatoryPending: RegulatoryPending;
  @SettingsModule.value(RegulatoryApproved) regulatoryApproved: RegulatoryApproved;
  @SettingsModule.value(RegulatoryRejected) regulatoryRejected: RegulatoryRejected;
  @SettingsModule.value(SponsorPending) sponsorPending: SponsorPending;
  @SettingsModule.value(SponsorApproved) sponsorApproved: SponsorApproved;
  @SettingsModule.value(SponsorRejected) sponsorRejected: SponsorRejected;
  @SettingsModule.value(WorkflowQueryResolutionSent) workflowQueryResolutionSent: WorkflowQueryResolutionSent;
  @SettingsModule.value(AuditQueryResolutionSent) auditQueryResolutionSent: AuditQueryResolutionSent;
  @SettingsModule.value(NewQuestion) newQuestion: NewQuestion;
  @SettingsModule.value(NewAnswer) newAnswer: NewAnswer;
  @SettingsModule.value(FirstVisit) firstVisit: FirstVisit;
  @SettingsModule.value(Registration) registration: Registration;
  @SettingsModule.value(SwimLane) swimLane: SwimLane;
  @SettingsModule.value(Claim) claim: Claim;
  @SettingsModule.value(Reminder) reminder: Reminder;
  @SettingsModule.value(Escalation) escalation: Escalation;
  @SettingsModule.value(Release) release: Release;
  @SettingsModule.value(TestMode) testMode: TestMode;
  @SettingsModule.value(General) general: General;
  @SettingsModule.value(MiniNewsLetter) miniNewsLetter: MiniNewsLetter;
}
